import SuccessRoundImage from '../../assets/images/success-round.webp';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import { CompleteQueryParams } from './CompletePage';
import WalletIcon from '../../components/shared/Icons/WalletIcon';
import NavigationUtils from '../../utils/navigation.utils';
import WorldIcon from '../../components/shared/Icons/WorldIcon';
import FormatterUtils from '../../utils/formatter.utils';
import InfoOutlinedIcon from '../../components/shared/Icons/InfoOutlinedIcon';

export const CompletePageSuccessType = {
  CREDIT_ONBOARDING_SUCCESS: 'credit-onboarding-success',
  CREDIT_ONBOARDING_APPROVED: 'credit-onboarding-approved',
  CREDIT_MICROLOAN_SUCCESS: 'credit-microloan-success',
  CREDIT_REPAY_SUCCESS: 'credit-repay-success',
  DEBIT_ONBOARDING_SUCCESS: 'debit-onboarding-success',
  POS_SUCCESS: 'pos-success',
  SEND_MONEY_TO_COMPANY_SUCCESS: 'send-money-to-company-success',
  ONBOARDING_APPROVED_AUTO_LENDING: 'onboarding-auto-lending',
  ONBOARDING_APPROVED_AUTO_LENDING_PERSONALIZED:
    'onboarding-auto-lending-personalized',
};

const navigateToPickup = () => {
  NavigationUtils.navigate(NavigationUtils.Routes.PICKUP);
};

const navigateToCreditOnboarding = () => {
  NavigationUtils.navigate(NavigationUtils.Routes.CREDIT_ONBOARDING);
};

export const SuccessConfig = (dictionary, t, getOrganization) => {
  return {
    [CompletePageSuccessType.CREDIT_ONBOARDING_SUCCESS]: {
      image: SuccessRoundImage,
      title: t('Reviewing credit application', {
        '{company_name}': getOrganization(
          dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        ),
      }),
      subtitle: t(
        'Visit a {company_name} partner branch to speed up your credit approval',
        {
          '{company_name}': getOrganization(
            dictionary[CompleteQueryParams.ORGANIZATION_CODE],
          ),
        },
      ),
      ctaText: t('Go back to home'),
      ctaAction: () => {
        CloseWebviewEvent.closedByUser();
      },
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageSuccessType.CREDIT_ONBOARDING_APPROVED]: {
      image: SuccessRoundImage,
      title: t(
        "Congratulations! you're approved for your {company_name} credit",
        {
          '{company_name}': getOrganization(
            dictionary[CompleteQueryParams.ORGANIZATION_CODE],
          ),
        },
      ),
      subtitle: t('Visit one of our booths to activate your credit'),
      ctaText: t('Go back to home'),
      ctaAction: () => {
        CloseWebviewEvent.closedByUser();
      },
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageSuccessType.CREDIT_MICROLOAN_SUCCESS]: {
      image: SuccessRoundImage,
      title: t('Credit used successfully'),
      subtitle: t(
        'Your first installments payment on this amount will be due on your next installment due date',
      ),
      text: t('You moved EGP {amount} to your current account', {
        '{amount}': FormatterUtils.currency(
          dictionary[CompleteQueryParams.AMOUNT],
        ),
      }),
      ctaText: t('Go to wallet'),
      ctaAction: () => {
        NavigationUtils.navigate(NavigationUtils.Routes.WALLET, true, {
          organization: dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        });
      },
      icon: <WalletIcon />,
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageSuccessType.CREDIT_REPAY_SUCCESS]: {
      image: SuccessRoundImage,
      title: t('EGP {amount} paid to installments account', {
        '{amount}': FormatterUtils.currency(
          dictionary[CompleteQueryParams.AMOUNT],
        ),
      }),
      ctaText: t('Go to wallet'),
      ctaAction: () => {
        NavigationUtils.navigate(NavigationUtils.Routes.WALLET, true, {
          organization: dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        });
      },
      list: [
        {
          icon: <WalletIcon />,
          subtitle: t('Transaction ID #{transactionId}').replace(
            '{transactionId}',
            dictionary[CompleteQueryParams.TRANSACTION_ID],
          ),
        },
        {
          icon: <WorldIcon />,
          subtitle: dictionary[CompleteQueryParams.CREATED_AT]
            ? FormatterUtils.formatDateCustom(
                dictionary[CompleteQueryParams.CREATED_AT],
                t,
              )
            : '',
        },
      ],
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageSuccessType.DEBIT_ONBOARDING_SUCCESS]: {
      image: SuccessRoundImage,
      title: t(`You're approved for {card name}`, {
        '{card name}': getOrganization(
          dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        ),
      }),
      list: [
        {
          icon: <InfoOutlinedIcon />,
          subtitle: t(
            `Visit a {card name} pick up point to collect and activate your new card!`,
            {
              '{card name}': getOrganization(
                dictionary[CompleteQueryParams.ORGANIZATION_CODE],
              ),
            },
          ),
        },
        {
          icon: <InfoOutlinedIcon />,
          subtitle: t(
            `You are also eligible to apply for credit! Get up to {amount} EGP and pay it later in installments`,
            {
              '{amount}': FormatterUtils.currency(
                dictionary[CompleteQueryParams.AMOUNT],
              ),
            },
          ),
        },
      ],
      ctaText: t('Apply for credit'),
      ctaAction: navigateToCreditOnboarding,
      secondaryCtaText: t('See pick up locations'),
      secondaryCtaAction: navigateToPickup,
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageSuccessType.ONBOARDING_APPROVED_AUTO_LENDING]: {
      image: SuccessRoundImage,
      title: t(`You're approved for {card name}`, {
        '{card name}': getOrganization(
          dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        ),
      }),
      list: [
        {
          icon: <InfoOutlinedIcon />,
          subtitle: t(
            `Visit a {card name} pick up point to collect and activate your new card!`,
            {
              '{card name}': getOrganization(
                dictionary[CompleteQueryParams.ORGANIZATION_CODE],
              ),
            },
          ),
        },
        {
          icon: <InfoOutlinedIcon />,
          subtitle: t(`You have a pre-approved credit`),
        },
      ],
      ctaText: t('See pick up locations'),
      ctaAction: navigateToPickup,
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageSuccessType.ONBOARDING_APPROVED_AUTO_LENDING_PERSONALIZED]: {
      image: SuccessRoundImage,
      title: t(`You're approved for {card name}`, {
        '{card name}': getOrganization(
          dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        ),
      }),
      list: [
        {
          icon: <InfoOutlinedIcon />,
          subtitle: t(`You have a pre-approved credit`),
        },
      ],
      ctaText: t('Close'),
      ctaAction: () => {
        CloseWebviewEvent.closedByUser();
      },
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageSuccessType.POS_SUCCESS]: {
      image: SuccessRoundImage,
      title: t('POS top-up completed!'),
      text: t('EGP {amount} was sent to your POS', {
        '{amount}': FormatterUtils.currency(
          dictionary[CompleteQueryParams.AMOUNT],
        ),
      }),
      ctaText: t('See transactions'),
      ctaAction: () => {
        NavigationUtils.navigate(NavigationUtils.Routes.WALLET, true, {
          organization: dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        });
      },
      icon: <WalletIcon />,
      list: [
        {
          icon: <WalletIcon />,
          subtitle: t('Transaction ID #{transactionId}').replace(
            '{transactionId}',
            dictionary[CompleteQueryParams.TRANSACTION_ID],
          ),
        },
        {
          icon: <WorldIcon />,
          subtitle: dictionary[CompleteQueryParams.CREATED_AT]
            ? FormatterUtils.formatDateCustom(
                dictionary[CompleteQueryParams.CREATED_AT],
                t,
              )
            : '',
        },
      ],
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
    [CompletePageSuccessType.SEND_MONEY_TO_COMPANY_SUCCESS]: {
      image: SuccessRoundImage,
      title: t('Money sent successfully!'),
      text: t('EGP {amount} was sent to {company_name} Company', {
        '{amount}': FormatterUtils.currency(
          dictionary[CompleteQueryParams.AMOUNT],
        ),
        '{company_name}': getOrganization(
          dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        ),
      }),
      ctaText: t('See transactions'),
      ctaAction: () => {
        NavigationUtils.navigate(NavigationUtils.Routes.WALLET, true, {
          organization: dictionary[CompleteQueryParams.ORGANIZATION_CODE],
        });
      },
      icon: <WalletIcon />,
      list: [
        {
          icon: <WalletIcon />,
          subtitle: t('Transaction ID #{transactionId}').replace(
            '{transactionId}',
            dictionary[CompleteQueryParams.TRANSACTION_ID],
          ),
        },
        {
          icon: <WorldIcon />,
          subtitle: dictionary[CompleteQueryParams.CREATED_AT]
            ? FormatterUtils.formatDateCustom(
                dictionary[CompleteQueryParams.CREATED_AT],
                t,
              )
            : '',
        },
      ],
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
  };
};
